export default "__VITE_ASSET__DcwC$3EB__"